export default __webpack_public_path__ + "static/media/crowdshot.ce17785b.jpg";